import { render, staticRenderFns } from "./CodeGeneratorCategoryForm.vue?vue&type=template&id=24e63351&scoped=true&"
import script from "./CodeGeneratorCategoryForm.vue?vue&type=script&lang=js&"
export * from "./CodeGeneratorCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./CodeGeneratorCategoryForm.vue?vue&type=style&index=0&id=24e63351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e63351",
  null
  
)

export default component.exports